import TextField from "../../../form/TextField"
import SelectField from "../../molecules/SelectField/SelectField"
import React from "react"

function SelectOrTextInput(props) {
  const { name, label, options, isLoading, placeholder, disabled, isSelect = true } = props

  return isSelect ? (
    <SelectField
      name={name}
      options={options}
      isLoading={isLoading}
      label={label}
      placeholder={placeholder}
      openMenuOnFocus={true}
      enableMatchLabel={true}
      disabled={disabled}
    />
  ) : (
    <TextField name={name} label={label} trimOnBlur={true} disabled={disabled} />
  )
}

export default SelectOrTextInput
